exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SocialLogin-displayFlex-1BRox {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t    -ms-flex-align: center;\r\n\t        align-items: center;\r\n}\r\n\r\n.SocialLogin-marginRight-vLP8i {\r\n\tmargin-right: 23px;\r\n}\r\n\r\n.SocialLogin-center-3zBr-{\r\n\t-webkit-box-pack: center;\r\n\t    -ms-flex-pack: center;\r\n\t        justify-content: center;\r\n}", ""]);

// exports
exports.locals = {
	"displayFlex": "SocialLogin-displayFlex-1BRox",
	"marginRight": "SocialLogin-marginRight-vLP8i",
	"center": "SocialLogin-center-3zBr-"
};